import { supabase } from "../../lib/supabase";

/**
 * استدعاء Supabase Edge Function مع توكن المشرف
 * المشرف يجب أن يكون مسجلاً دخوله قبل استدعاء هذه الدالة
 */
export async function callEdgeFunction(functionName, body) {
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();

  if (sessionError || !sessionData?.session) {
    throw new Error("يجب تسجيل الدخول أولاً للقيام بهذه العملية.");
  }

  const accessToken = sessionData.session.access_token;
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  const response = await fetch(`${supabaseUrl}/functions/v1/${functionName}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      apikey: anonKey,
    },
    body: JSON.stringify(body),
  });

  let responseData;
  try {
    responseData = await response.json();
  } catch {
    const text = await response.text();
    throw new Error(`استجابة غير صحيحة من الخادم: ${text}`);
  }

  if (!response.ok) {
    if (response.status === 401) throw new Error("انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.");
    if (response.status === 403) throw new Error("غير مصرح لك بهذه العملية.");
    throw new Error(responseData?.error || responseData?.message || `خطأ ${response.status}`);
  }

  return responseData;
}
